import React from "react"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import CodingGIF from "../assets/codingGuy.gif"
import Fade from "react-reveal/Fade"

const useStyles = makeStyles((theme) => ({
	box: {
		width: "auto",
		display: "flex",
		justifyContent: "center",
	},
	boxImg: {
		maxWidth: "100%",
		width: "75%",
		height: "auto" /* vary this to your needs ie auto, 100%, etc */,
		margin: "0 auto"
	}
}))

const BottomSvg = ({ isLoaded }) => {
	const theme = useTheme()
	const classes = useStyles()
	return (
		//     <svg width="300" height="300" style={{border: "1px solid black"}}>
		//   <circle stroke="white" stroke-width="1" r="100" cx="150" cy="150" fill="black" />
		//   <circle id="dot" r="10" cx="50" cy="150" fill="#07CFF6" />
		//       <animateTransform href="#dot" attributeName="transform" type="rotate" from="0 150 150" to="360 150 150" dur="5s" repeatCount="indefinite" />

		//       <path d="M10,80 a60,60 0 0,1 115,0" fill="black" stroke="white" stroke-width="1"/>
		//       <circle id="dota" r="10" cx="50" cy="150" fill="#07CFF6" />
		//       <animateTransform href="#dota" attributeName="transform" type="rotate" from="M10,80 a60" to="360" dur="5s" repeatCount="indefinite" />
		// </svg>
		//     <div>
		//       <section id="microdonation_circle" >
		//   <svg class="spinner" width="174px" height="174px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
		//      <circle class="path" fill="transparent" stroke-width="2" cx="33" cy="33" r="30" stroke="url(#gradient)"/>
		//        <linearGradient id="gradient">
		//          <stop offset="50%" stop-color="#e99586" stop-opacity="1"/>
		//          <stop offset="65%" stop-color="#e99586" stop-opacity="1"/>
		//          <stop offset="100%" stop-color="#e99586" stop-opacity="1"/>
		//        </linearGradient>
		//     <circle/>
		//     {/* <text x="50%" y="50%" text-anchor="middle" fill="black" font-size="10px" font-family="Arial" dy=".3em">test</text> */}
		//     <svg class="spinner-dot dot" width="5px" height="5px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" x="37" y="1.2">
		//        <circle class="path" fill="#e99586" cx="33" cy="33" r="8" />
		//       <circle/>
		//     </svg>
		//   <svg class="spinner-dot dot" width="5px" height="5px" viewBox="00 0 66 66" xmlns="http://www.w3.org/2000/svg" x="36" y="60">
		//        <circle class="path" fill="#e99586" cx="33" cy="33" r="8" />
		//       <circle/>
		//     </svg>
		//   </svg>
		// <h2>850000</h2>
		// <small>usd</small>
		// <img src="http://cirrusofttest.qmi.it/wp-content/uploads/2019/12/arrow.png" id="freccia1"/>
		// <img src="http://cirrusofttest.qmi.it/wp-content/uploads/2019/12/arrow.png" id="freccia2"/>
		// <img src="http://cirrusofttest.qmi.it/wp-content/uploads/2019/12/arrow.png" id="freccia3"/>
		// <img src="http://cirrusofttest.qmi.it/wp-content/uploads/2019/12/arrow.png" id="freccia4"/>
		// <img src="http://cirrusofttest.qmi.it/wp-content/uploads/2019/12/heart_pink.png" id="heart1"/>
		// <img src="http://cirrusofttest.qmi.it/wp-content/uploads/2019/12/heart_pink.png" id="heart2"/>
		// </section>
		//     </div>
		<>
			{isLoaded ? (
				<div className={classes.box}>
					<Fade bottom>
						<img
							className={classes.boxImg}
							src={CodingGIF}
							alt="Alternative text for your GIF"
						/>
					</Fade>
				</div>
			) : null}
		</>
	)
}

export default BottomSvg
